import { Injectable } from '@angular/core';
import { Dropdown, DropdownAdapter } from 'src/app/models/dropdown.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DropdownsService {

  constructor(private _http: HttpClient, private _adapter: DropdownAdapter) {}

  getDeviceGroups(): Observable<Dropdown[]>{
    return this._http.get<Dropdown[]>('device-groups').pipe(map((data: any) => data.map(item => this._adapter.adapt(item))));   
  }
  
  getDeviceTypes(): Observable<Dropdown[]>{
    return this._http.get<Dropdown[]>('device-types').pipe(map((data: any) => data.map(item => this._adapter.adapt(item))));   
  }

  getSensorProfiles(): Observable<Dropdown[]>{
    return this._http.get<Dropdown[]>('sensor-profiles').pipe(map((data: any) => data.map(item => this._adapter.adapt(item))));   
  }

  getStatuses(): Observable<Dropdown[]>{
    return this._http.get<Dropdown[]>('devices').pipe(map((data: any) => data.map(item => this._adapter.adapt(item))));   
  }
}
